import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Leads from '@/components/Leads'
import VueResource from 'vue-resource'

Vue.use(VueResource)  

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
	{
      path: '/leads',
      name: 'Leads',
      component: Leads
    },	
    {
        path: '/*',
        redirect: '/'
    },
  ]
})